import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-applicant-dialog',
  templateUrl: './add-applicant-dialog.component.html',
  styleUrls: ['./add-applicant-dialog.component.css']
})
export class AddApplicantDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
